import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "@/lib/drivers/tandem/TandemTypes";
import { cz } from "@/utils/zodUtils";

export type TubingFilledPayload = {
  prime_size?: number;
};

export type TubingFilledEvent = {
  primeSize?: number;
};

const tubingFilledSchema = z.object({
  prime_size: cz.permissive(z.number()),
});

export const LID_TUBING_FILLED = {
  value: 0x3f,
  name: "Tubing Filled Event",
  format: "f............",
  fields: ["prime_size"],

  postprocess: rec => ({
    primeSize: rec.prime_size,
  }),
  schema: tubingFilledSchema,
} as const satisfies TandemEventDefinition<TubingFilledPayload, TubingFilledEvent>;
